module.exports = __webpack_public_path__ + "img/pattern_1.f1941a52.png";